<script>
</script>

<header class="header">
    <div class="mobile hd-title inner">
        <div class="hd-title-wrap">
            <img
                src="../resource/img/img_logo.png"
                alt=""
                class="m-logo m-logo-center"
            />
        </div>
    </div>
</header>
